import React from 'react'

import styled from 'styled-components'

import { Collapse } from 'src/Components/Collapse'
import { SpotifyCampaignReview } from 'src/Redux/artistSpotifyCampaignReviewApi'

import { AccentText } from '../ReviewBlock'
import { AddedPlaylistInfo } from '../AddedPlaylistInfo'

import { convertToPublicSpotifyUrl } from './helpers'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
`

export interface MatchedPlaylistsProps {
  matchedTrackPlaylists: SpotifyCampaignReview['matchedPlaylists']
}

export const MatchedPlaylists: React.FC<MatchedPlaylistsProps> = ({
  matchedTrackPlaylists,
}) => (
  <Collapse
    items={[
      {
        label: <AccentText>Matched playlists</AccentText>,
        children: (
          <Container>
            {matchedTrackPlaylists?.map((playlist) => (
              <AddedPlaylistInfo
                key={playlist.name}
                playlistName={playlist.name || ''}
                playlistUrl={convertToPublicSpotifyUrl(playlist.url || '')}
                // need task on BE to return playlist cover url in matched playlists response
                playlistCoverUrl={playlist.cover || ''}
              />
            ))}
          </Container>
        ),
      },
    ]}
  />
)
